import { motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ColumnsTable, Components, HeaderActions, IMoneyAccount, ISell } from 'safe'
import Empty from '../../../components/Display/Empty'
import Table from '../../../components/Display/Table'
import { ColumnItemWrapper } from '../../../components/General/ColumnItemWrapper'
import { RootState } from '../../../redux/store'
import EmptyHistoric from '../../../assets/animations/historico.json'
import {
  formatAmount,
  formatPipe,
  formatter,
  getSellStatus,
  getYearMonthAndDay,
} from '../../../utils/utils'
import ViewWithTabs, {
  DataTabView,
} from '../../../components/Display/ViewWithTabs'
import Modal from '../../../components/Display/Modal'
import { fetchSells } from '../../../redux/actions/sells'
import { useLocalStorageState } from '../../../hooks/useLocalStorageState'
import { useForm } from 'react-hook-form'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Select from '../../../components/Inputs/Select'
import Button from '../../../components/General/Button'
import InputText from '../../../components/Inputs/InputText'
import SelectOfCategories from '../../../components/Inputs/SelectOfCategories'
import InputNumber from '../../../components/Inputs/InputNumber'
import CurrencyInput from '../../../components/Inputs/CurrencyInput'
import Bancrecer from '../../../assets/images/bancrecer.svg';
import { IGlobalRate } from '../../../views/Sells/Sells'

const OnlinePaymentForm: React.FC<C2PFormProps> = ({
  onCancel,
  onSubmitProp,
  debt,
  rate
}) => {
  const form = useForm({defaultValues: {
    amount: `Bs. ${0}`
  }})

  const onSubmit = (values): void => {
    onSubmitProp({...values, amount: formatPipe(values.amount, true)})
  }
  
  const amountRef = useRef<any>()

  useEffect(() => {
    if (amountRef.current) {
      form.register(amountRef.current)
      amountRef.current.focus()
    }
  }, [])
  
  return (
    <>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        // id={id}
        onSubmit={(values) => onSubmit(values)}
      >
        <div className="col-span-12" style={{fontWeight: 500}}>Pago en línea (C2P)</div>
        {/* <div className="col-span-12">DEUDA: BS {formatPipe(debt)}</div>
        <div className="col-span-12">DEUDA EN USD (REF.): { formatPipe((+debt / +(rate.find(r => r.id === "1")?.rate || 1)).toFixed(2)) }</div> */}

        {/* <div className="col-span-3">MONTO</div> */}
        <FormItem
          name="amount"
          classes="col-span-12"
          defaultValue={''}
          rules={{
            required: 'Es necesario el monto',
            // pattern: { value: /^\d+(\.\d{2})?$/, message: 'Monto inválido' },
          }}
        >
          {/* <InputText small maxLength={80} /> */}
          {/* <InputNumber addDecimals={true} label='Monto' focusFirstRender={true} /> */}
          <CurrencyInput addDecimals={true} label='Monto' mask='Bs. num' />
        </FormItem>

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={() => onCancel()}>
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit">
              Continuar
            </Button>
          </div>
        </div>

        <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      <div className='col-span-12 mt-3 flex flex-col items-center'>
          <label className='text-center text-sm' style={{color: '#7C7C7C'}}>Operación realizada a través de la plataforma de Bancrecer</label>
          <div className='mt-3'>
          <img src={Bancrecer} height={100} width={100}/>
          </div>
      </div>

      </Form>
    </>
  )
}

interface C2PFormProps {
  onSubmitProp: Function
  onCancel: Function
  debt: string
  rate: IGlobalRate[]
}

interface options {
  value: string
  text: string
}

enum valuesEnum {
  national = 'nationalTransfer',
  mobile = 'mobilePayment',
}

export default OnlinePaymentForm